import React from "react";
import { useDataSourceManagement } from "../lib/useDataSourceManagement";
import InviteTeammate from "../components/InviteTeammate";
import { showsInviteTeammate } from "../lib/first-run";
import { useDatasources } from "../lib/useDatasources";

/**
 * MOSA-695 item 12. One centred column holds every card at the same width.
 * The page sets no min-height: `min-h-screen` plus the sticky top bar made a
 * scrollbar on a page that fits.
 */
const DataSources: React.FC = () => {
  const { dataSourcesManager } = useDataSourceManagement();
  const { datasources, isInitialLoad } = useDatasources();
  const showsInvite = showsInviteTeammate({ datasources, isInitialLoad });

  return (
    <div className="bg-od-bg text-od-text p-4">
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-4">
        {dataSourcesManager}
        {showsInvite && <InviteTeammate />}
      </div>
    </div>
  );
};

export default DataSources;
